import React from 'react';
import {
  default as MuiInputLabel,
  type InputLabelProps as MuiInputLabelProps,
} from '@mui/material/InputLabel';
import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';
import { DistributiveOmit } from '@mui/types';

/**
 * Props that we do not want to include with InputLabel.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type InputLabelBlockedProps = keyof Pick<
  MuiInputLabelProps,
  'variant' | 'filled'
>;

export interface InputLabelTypeMap<
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {},
  RootComponent extends React.ElementType = 'label'
> {
  props: AdditionalProps &
    DistributiveOmit<MuiInputLabelProps, InputLabelBlockedProps>;
  defaultComponent: RootComponent;
}

export type InputLabelProps<
  RootComponent extends React.ElementType = InputLabelTypeMap['defaultComponent'],
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {}
> = OverrideProps<
  InputLabelTypeMap<AdditionalProps, RootComponent>,
  RootComponent
> & {
  component?: React.ElementType;
};

export const InputLabel: OverridableComponent<InputLabelTypeMap> =
  MuiInputLabel;
